import { useState } from 'react';

const testimonials = [
  {
    quote:
      'Family Tree Maker is simply the best genealogy software available. It is intuitive, powerful, and has helped me discover so much about my family history.',
    name: 'John S.',
    location: 'San Jose, CA',
  },
  {
    quote:
      'I have been using Family Tree Maker for over 10 years and it just keeps getting better. The cloud sync feature is a game-changer.',
    name: 'Mary K.',
    location: 'Austin, TX',
  },
  {
    quote:
      'The integration with FamilySearch makes research so much easier. I found ancestors I never knew existed.',
    name: 'Robert T.',
    location: 'Seattle, WA',
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex];

  return (
    <section className="t7-section t7-section--white">
      <div className="container">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-8 lg:gap-16 items-start lg:items-end">
          <div className="t7-head t7-head--rail mb-0">
            <p className="t7-kicker">Stories</p>
            <h2 className="t7-title">What customers say</h2>
            <p className="t7-lead mb-5 md:mb-6">
              Real feedback from people documenting their families with Family Tree Maker.
            </p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                className="h-11 w-11 border border-[#c5d9cb] text-[#166534] hover:bg-[#dcfce7] transition-colors touch-manipulation"
                aria-label="Previous testimonial"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => setCurrentIndex((prev) => (prev + 1) % testimonials.length)}
                className="h-11 w-11 border border-[#c5d9cb] text-[#166534] hover:bg-[#dcfce7] transition-colors touch-manipulation"
                aria-label="Next testimonial"
              >
                →
              </button>
            </div>
          </div>

          <blockquote className="bg-[#eef6ef] border-l-4 border-[#166534] p-5 sm:p-8 md:p-10 m-0">
            <p className="font-serif text-lg sm:text-xl md:text-2xl text-[#14201a] leading-snug mb-6 md:mb-8">
              “{current.quote}”
            </p>
            <footer className="flex items-start sm:items-center justify-between gap-3 flex-wrap">
              <cite className="not-italic font-semibold text-[#166534] text-sm sm:text-base">
                {current.name}
                <span className="font-normal text-[#4d5c54]"> — {current.location}</span>
              </cite>
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => setCurrentIndex(index)}
                    className={`h-2.5 w-2.5 rounded-full transition-colors touch-manipulation ${
                      index === currentIndex ? 'bg-[#166534]' : 'bg-[#c5d9cb]'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
